@let data = serialNumber();

@if (data | isDefinedNotEmpty) {
  @if (data?.mandatory || data?.editable) {
    @let number = data?.seriennummer;
    <soft-chip
      [canDelete]="false"
      (click)="editable() && openEditModal()"
      [class]="
        '!text-xs font-semibold !px-2 !py-0.5' +
        ((number | isDefinedNotEmpty)
          ? editable()
            ? '!bg-primary-50 !text-primary-600 !border !border-primary-600 hover:!cursor-pointer hover:!bg-primary hover:!text-primary-contrast'
            : ''
          : '!bg-danger-50 !text-danger-600 !border !border-danger-600')
      "
      >Serien-Nr.: {{ number }}
      @if (editable()) {
        <soft-icon name="fa-regular fa-pencil !text-xs"></soft-icon>
      }
    </soft-chip>
  }
}
